import { z } from "zod";

import { DatabaseIdentity } from "@/core/api";
import { Attachment } from "@/data/attachments";
import { Location } from "@/data/locations/types/Location";
import { PhoneNumber } from "@/data/phones";

export const ConsultantProfileContactPerson = z
  .object({
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    phone: PhoneNumber.nullable(),
    avatar: Attachment.nullable(),
    position: z
      .object({
        name: z.string().nullable(),
      })
      .nullable(),
    location: Location.nullable(),
  })
  .merge(DatabaseIdentity)
  .passthrough();

export type ConsultantProfileContactPerson = z.infer<typeof ConsultantProfileContactPerson>;
